<template>
  <v-tooltip
      bottom
      :max-width="maxWidth"
      :content-class="tooltipClass"
      :open-delay="openDelay"
      :close-delay="closeDelay"
  >
    <template v-slot:activator="{ on }">
      <div v-on="on" class="kpi-tooltip-activator">
        <slot name="label"></slot>
        <v-icon :size="iconSize" :color="iconColor">{{ icon }}</v-icon>
      </div>
    </template>
    <div class="kpi-tooltip-content">
      <slot></slot>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: 'KpiTooltip',

  props: {
    // Largura máxima do tooltip
    maxWidth: {
      type: [String, Number],
      default: 280
    },
    // Ícone do tooltip
    icon: {
      type: String,
      default: 'mdi-help-circle-outline'
    },
    // Tamanho do ícone
    iconSize: {
      type: [String, Number],
      default: 'x-small'
    },
    // Cor do ícone
    iconColor: {
      type: String,
      default: '#94a3b8'
    },
    // Delay para abrir (ms)
    openDelay: {
      type: Number,
      default: 200
    },
    // Delay para fechar (ms)
    closeDelay: {
      type: Number,
      default: 100
    },
    // Classe CSS customizada
    tooltipClass: {
      type: String,
      default: 'kpi-tooltip-custom'
    }
  }
};
</script>

<style>
/* ── Estilos Globais do Tooltip (não scoped para afetar o Vuetify) ── */
.kpi-tooltip-custom {
  background: #1e293b !important;
  border-radius: 8px !important;
  padding: 12px 14px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
}

.kpi-tooltip-custom .kpi-tooltip-content {
  font-size: 0.813rem;
  line-height: 1.5;
  color: #f1f5f9;
  font-weight: 500;
  letter-spacing: 0.01em;
}

/* ✨ NOVO: Estilos para fórmulas/origens técnicas */
.kpi-tooltip-custom .kpi-tooltip-content .formula {
  display: inline-block;
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', Consolas, monospace;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border: 1px solid rgba(59, 130, 246, 0.3);
  margin: 0 2px;
}

.kpi-tooltip-custom .kpi-tooltip-content .origem {
  display: inline-block;
  background: rgba(168, 85, 247, 0.15);
  color: #c084fc;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', Consolas, monospace;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border: 1px solid rgba(168, 85, 247, 0.3);
  margin: 0 2px;
}
</style>

<style scoped>
.kpi-tooltip-activator {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: help;
  width: fit-content;
  transition: opacity 0.2s ease;
}

.kpi-tooltip-activator:hover {
  opacity: 0.8;
}
</style>